// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2A7ho","header":"MergedInvoice_header__ljypL"};